import { usePriceVolatilityQuery } from '@/services/queries/usePriceVolatility'
import { PriceVolatilityList } from './PriceVolatilityList'

export function PriceHistoryVolatilityPanel() {
  const { entries, isLoading, isError } = usePriceVolatilityQuery()

  return (
    <div className="space-y-4">
      <PriceVolatilityList entries={entries} isLoading={isLoading} isError={isError} />
    </div>
  )
}
